import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';


const CustomIconSelect = ({ icnId, onChange,moduleOption }) => {
  const selectedOption = moduleOption.find((opt) => opt.id === icnId);

  const handleSelect = (val) => {
    if(onChange) {
      onChange({ target: { name: 'icnImg', value: val } });
    }
  };

  return (
    <DropdownButton 
      id="custom-image-select" 
      title={
        selectedOption ? (
          <div style={{display: 'flex'}}>
            {selectedOption.id && selectedOption?.icon &&
            selectedOption?.icon
            }
            <span className={`${selectedOption?.icon ? 'mx-2':''}`}>{selectedOption.name}</span>
          </div>
        ) : (
          <div style={{display: 'flex'}}>

          <span>Select Module Icon</span>
          </div>
        )
      }
      variant="light"
      className="input1 custom-img-dropdown"
    >
      {moduleOption.map((opt) => (
        <Dropdown.Item 
          key={opt.id} 
          eventKey={opt.id} 
          onClick={()=>{handleSelect(opt.id)}}
          active={opt.id === icnId}
          style={{display: 'flex', alignItems: 'center'}}
          className='img-dropdown-item'
        >
        {opt.id &&
          opt?.icon
        }
          <span className='mx-2'>{opt.name}</span>
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default CustomIconSelect;

